// removed by extract-text-webpack-plugin
module.exports = {"root":"jt-multiplier--root--fXAayJrr home--root--2rXwqQ3Z organization-home--root--29mpR9MJ","address-list":"jt-multiplier--address-list--U0MnrQJl","addressList":"jt-multiplier--address-list--U0MnrQJl","reminder":"jt-multiplier--reminder--2AibHYXA"};


//////////////////
// WEBPACK FOOTER
// ./views/refunds/jt-multiplier/styles.css
// module id = ./views/refunds/jt-multiplier/styles.css
// module chunks = 0